import { render, staticRenderFns } from "./uploadAndAnalyzeNew.vue?vue&type=template&id=5daa06d3&scoped=true"
import script from "./uploadAndAnalyzeNew.vue?vue&type=script&lang=js"
export * from "./uploadAndAnalyzeNew.vue?vue&type=script&lang=js"
import style0 from "./uploadAndAnalyzeNew.vue?vue&type=style&index=0&id=5daa06d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daa06d3",
  null
  
)

export default component.exports